<template>
  <div class="container">
    <md-dialog :md-active.sync="modalEditar" :md-click-outside-to-close="false">
        <md-dialog-title class="text-center">
            {{ labels.title }}
        </md-dialog-title>
        <md-dialog-content>
            <!-- <pre>{{ infoTipoTasa[0] }}</pre> -->
            <b-row class="">
                <b-col cols="1"></b-col>
                <b-col cols="5" class="text-left">
                    <h5>{{labels.codigo}}</h5>
                </b-col>
                <b-col cols="6" class="text-left">
                    <h5>{{ infoTipoTasa[0].tipo_tasa }}</h5>
                </b-col>
            </b-row>
            <b-row class="">
                <b-col cols="1"></b-col>
                <b-col cols="5" class="text-left">
                    <h5>{{labels.descripcion}}</h5>
                </b-col>
                <b-col cols="6" class="text-left">
                    <input type="text" v-model="infoTipoTasa[0].descripcion" class="form-control">
                </b-col>
            </b-row>
            <b-row class="">
                <b-col cols="1"></b-col>
                <b-col cols="5" class="text-left">
                    <h5>{{labels.frecuencia}}</h5>
                </b-col>
                <b-col cols="6" class="text-left">
                    <input type="text" v-model="infoTipoTasa[0].frecuencia" class="form-control">
                </b-col>
            </b-row>
            <b-row class="">
                <b-col cols="1"></b-col>
                <b-col cols="5" class="text-left">
                    <h5>{{labels.modalidad}}</h5>
                </b-col>
                <b-col cols="6" class="text-left">
                    <select v-model="infoTipoTasa[0].modalidad" class="form-control">
                        <option value="">{{ labels.select }}</option>
                        <option value="A">{{ labels.anticipada }}</option>
                        <option value="F">{{ labels.fija }}</option>
                        <option value="V">{{ labels.vencida }}</option>
                    </select>
                </b-col>
            </b-row>
            <md-dialog-actions class="mt-3">
                <b-col cols="7" class="text-left">
                    <md-button class="md-accent" @click="eliminaRegistro">{{ labels.delete }}</md-button>
                </b-col>
                <b-col cols="3" class="text-right">
                    <md-button class="md-primary" @click="guardarTipoTasa">{{ labels.save }}</md-button>
                </b-col>
                <b-col cols="2" class="text-right">
                    <md-button class="md-accent" @click="cierraModal">{{ labels.close }}</md-button>
                </b-col>
            </md-dialog-actions>
        </md-dialog-content>
    </md-dialog>
    <InacticaItem :InactivaItem="deleteTipoTasa" @confirmDelete="confirmInactivate" @cierraModal="cierraModalDelet"/>
  </div>
</template>

<script>

import TipoTasa from '../../../services/TipoTasas';
import InacticaItem from '../../utils/InacticaItem';

export default {
    name : 'Editar',
    props : ['modalEditar','infoTipoTasa'],
    components:{InacticaItem},
    data: () => ({
        idTipoTasa : null,
        deleteTipoTasa : false
    }),
    computed:{
        labels(){
            if(this.$store.state._language == "es-ES"){
                return {
                    title : 'Editar Tipo Tasa',
                    delete : 'Eliminar',
                    save : 'Guardar',
                    close : 'Cerrar',
                    codigo : 'Código',
                    descripcion : 'Descripción',
                    frecuencia : 'Frecuencia',
                    modalidad : 'Modalidad',
                    select : 'Seleccione...',
                    anticipada : 'Anticipada',
                    fija : 'Fija',
                    vencida : 'Vencida'
                }
            }else{
                return {
                    title : 'Edit Rate Type',
                    delete : 'Delete',
                    save : 'Save',
                    close : 'Close',
                    codigo : 'Code',
                    descripcion : 'Description',
                    frecuencia : 'Frecuency',
                    modalidad : 'Type',
                    select : 'Select...',
                    anticipada : 'Anticipated',
                    fija : 'Fixed',
                    vencida : 'Expire'
                }
            }
        }
    },
    methods:{
        cierraModal(){
            this.$emit('cierraModal',false)
        },
        cierraModalDelet(){
            this.deleteTipoTasa = false
        },
        guardarTipoTasa(){
            const dataForm = [
                this.infoTipoTasa[0].codTipoTasa,
                this.infoTipoTasa[0].descripcion,
                this.infoTipoTasa[0].frecuencia,
                this.infoTipoTasa[0].modalidad
            ]

            if(dataForm.includes('')){
                this.$toast.error('Campo(s) pendiente(s) por diligenciar')
            }else{

                let info = {
                    'id' : this.infoTipoTasa[0].id,
                    'codigo' : this.infoTipoTasa[0].codTipoTasa,
                    'descripcion' : this.infoTipoTasa[0].descripcion,
                    'frecuencia' : this.infoTipoTasa[0].frecuencia,
                    'modalidad' : this.infoTipoTasa[0].modalidad,
                    'idUser' : this.$store.state.userId
                }
                // console.log(info);
                TipoTasa.updateTipoTasaById(info)
                .then((res) => {
                    if(res.status == 200){
                        this.$toast.success(res.data.message)
                        location. reload()
                    
                    }else if(res.status == 204){
                        this.$toast.error('Tipo tasa ingresada ya existe.')
                    }
                })
                .catch((error) => { console.log(error) })
            }
        },
        eliminaRegistro(){
            this.idTipoTasa = this.infoTipoTasa[0].id
            this.deleteTipoTasa = true
        },
        confirmInactivate(){
            TipoTasa.deleteTipoTasa(this.idTipoTasa)
            .then((res) => {
                if(res.status == 200){
                    this.$toast.success(res.data.message)
                    location. reload()                
                }
            })
            .catch((error) => error)
        }
    }
}
</script>

<style>

</style>
